// extracted by mini-css-extract-plugin
export default {"input":"oqa-z","button":"pqa-z","selected":"qqa-z","sephoraImage":"rqa-z","unavailable":"sqa-z","image":"tqa-z"};